/**
 * Created by guga on 8/29/2016.
 */
import { Injectable } from '@angular/core';
import {PRODUCTION_HOST} from "./api-host"
@Injectable()
export class ConfigSas {
//    private _apiHost : string='http://ec2-54-207-91-17.sa-east-1.compute.amazonaws.com/api';
   private _apiHost      : string = PRODUCTION_HOST;

    public constructor() {
    }

    get apiHost() : string {
        return this._apiHost;
    }
}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/sas/config.sas.ts